function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc from 'dc';
import { BaseMixin } from '../Mixins/BaseMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import { CapMixin } from '../Mixins/CapMixin';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { TileMixin } from '../Mixins/TileMixin';
import './SunburstChart.scss';
export var SunburstChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SunburstChart, _Component);

  function SunburstChart(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.chart = null;
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = SunburstChart.prototype;

  _proto.getChart = function getChart() {
    return this.chart;
  };

  _proto.componentDidMount = function componentDidMount() {
    this.chart = dc.sunburstChart(this.chartRef.current);
    BaseMixin(this.chart, this.props);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    var _this$props = this.props,
        emptyTitle = _this$props.emptyTitle,
        externalLabels = _this$props.externalLabels,
        innerRadius = _this$props.innerRadius,
        minAngleForLabel = _this$props.minAngleForLabel,
        radius = _this$props.radius;
    this.chart.emptyTitle(emptyTitle).externalLabels(externalLabels).innerRadius(innerRadius).minAngleForLabel(minAngleForLabel).radius(radius).render();
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: this.props.chartTitle,
      getChart: this.getChart,
      showTools: this.props.showTools,
      toolsComponent: this.props.toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: "avi-chart chart sunburst-chart",
      ref: this.chartRef
    }));
  };

  return SunburstChart;
}(Component);

_defineProperty(SunburstChart, "defaultProps", {
  emptyTitle: '',
  externalLabels: false,
  innerRadius: 0,
  minAngleForLabel: 0.25,
  radius: 200
});

SunburstChart.propTypes = process.env.NODE_ENV !== "production" ? {
  emptyTitle: PropTypes.string,
  externalLabels: PropTypes.bool,
  innerRadius: PropTypes.number,
  minAngleForLabel: PropTypes.number,
  radius: PropTypes.number
} : {};
export default SunburstChart;